import {Button, Modal, Input, Radio, ModalContent, ModalHeader, ModalBody, Select, SelectItem} from "@nextui-org/react";
import {useState} from "react";
import {countries, countryIcon, times, traffics} from "../Utils";
import axios from "../axios";
import {toast} from "react-toastify";

const CreateServiceModal = ({plans}) => {
    const [name, setName] = useState("")
    const [plan, setPlan] = useState(null)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false)

    const submit = () => {
        setLoading(true);

        axios.post("/create", {
            name: name,
            planId: parseInt(plan)
        }).then(r => {
            setOpen(false)
            toast.success("سرور جدید ساخته شد")
            setTimeout(() => {
                window.location.reload();
            }, 2000)
        }).catch((err) => {
            toast.error(err.response.data.message)
        }).finally(() => setLoading(false))
    }


    const price = () => {
        if (!plan) {
            return 0
        }

        return plans.find(p => p.id == plan).resellerPrice
    }

    return (
        <>
            <Button color="danger" onClick={
                () => setOpen(true)
            }
                    size="lg"
            >
                سرویس جدید
            </Button>

            <Modal
                aria-labelledby="modal-title"
                open={open}
                isOpen={open}
                onClose={() => setOpen(false)}
                width={"500px"}
            >
                <ModalContent>
                    <ModalHeader>
                        <h3>
                            New Service
                        </h3>
                    </ModalHeader>

                    <ModalBody>
                        <h3>
                            Price : {new Intl.NumberFormat().format(price())} T
                        </h3>
                        <Input
                            variant="faded"
                            fullWidth
                            size="lg"
                            onChange={(e) => setName(e.target.value)}
                            placeholder="name"
                        />

                        <Select
                            variant="faded"
                            label="Select a plan"
                            fullWidth
                            disallowEmptySelection
                            onChange={(e) => setPlan(e.target.value)}
                        >
                            {plans.map((t) => (
                                <SelectItem key={t.id} value={t.id}>
                                    {`${t.time} Days, ${t.traffic} GB`}
                                </SelectItem>
                            ))}
                        </Select>

                        <Button color="success" className="text-white" isDisabled={!name} onPress={submit}
                                isLoading={loading}>
                            ساخت سرویس
                        </Button>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default CreateServiceModal;